const translations = {
	sk: {
		"Kč / den": "€ / deň"
	}
}

export function defaultLocale() {
	return "cs";
}

export function currentLocale() {
	return document.querySelector("html").getAttribute("lang") || "cs";
}

export function _(message) {
	const locale = currentLocale();

	if (locale == defaultLocale()) {
		return message;
	}
	else if (message in translations[locale]) {
		return translations[locale][message];
	}
	else {
		console.error(`Cannot find translation for: "{message}"`);
		return message;
	}
}